import type { Copy } from '../types/copy'

export const es: Copy = {
  nav: {
    services: 'Servicios',
    gallery: 'Galería',
    about: 'Nosotros',
    process: 'Proceso',
    contact: 'Contacto',
    quote: 'Cotización Gratis',
    callUs: 'Llámenos',
    menu: 'Abrir menú',
    close: 'Cerrar menú',
    language: 'Idioma',
  },
  hero: {
    eyebrow: 'Haz Tu Hogar Realidad',
    headline: 'Construcción y Reparación',
    headlineAccent: 'Completa Para Tu Hogar',
    sub: 'Desde el techo hasta el granito, atendemos todas tus necesidades del hogar con trabajo experto.',
    badges: ['Con Licencia y Asegurados', '20+ Años de Experiencia', 'Estimados Gratis'],
    primary: 'Cotización Gratis',
    secondary: 'Ver Nuestro Trabajo',
    serving: 'Servicio en San Ysidro, CA',
    locationLine: 'Servicio en San Ysidro, California | Con Licencia y Asegurados',
    callNow: 'Llamar ahora',
  },
  trust: {
    items: [
      { id: 'years', value: '20+', label: 'Años en Todos los Servicios' },
      { id: 'projects', value: '1000+', label: 'Proyectos Terminados' },
      { id: 'inhouse', value: 'Propio', label: 'Equipo Propio, Sin Subcontratar' },
      { id: 'licensed', value: 'Lic. 1126459', label: 'Con Licencia y Seguro' },
    ],
    note: 'La opción de confianza en San Ysidro. El mismo equipo y la misma calidad, de un techo con goteras a una isla de granito.',
  },
  services: {
    title: 'Nuestros Servicios',
    subtitle:
      'Desde reparación de techos hasta cubiertas de granito premium, atendemos todas tus necesidades del hogar. Construcción y renovación de servicio completo.',
    learnMore: 'Saber Más',
    items: [
      {
        id: 'granite-countertops',
        name: 'Cubiertas de Granito',
        description:
          'Selección de losas premium, plantilla de precisión, fabricación e instalación para cocinas, baños y barras.',
      },
      {
        id: 'kitchen-remodeling',
        name: 'Remodelación de Cocinas',
        description:
          'Renovación completa con gabinetes a medida, cubiertas de granito, nuevos diseños, iluminación y carpintería.',
      },
      {
        id: 'bathroom-design',
        name: 'Diseño de Baños',
        description:
          'Baños modernos con tocadores de granito, regaderas con azulejo y grifería, impermeabilizados y según código.',
      },
      {
        id: 'roofing',
        name: 'Servicios de Techos',
        description:
          'Reparación, reemplazo e instalación de techos residenciales y comerciales, incluyendo flashing y ventilación.',
      },
      {
        id: 'drywall-interior',
        name: 'Drywall e Interiores',
        description:
          'Instalación de drywall, parches, cinta, textura y acabado, además de estructura y reparación de muros.',
      },
      {
        id: 'wood-rot-repair',
        name: 'Reparación de Madera Podrida',
        description:
          'Tratamiento de madera podrida estructural, reemplazo de fascia y molduras, con madera tratada y sellada.',
      },
      {
        id: 'tile-flooring',
        name: 'Azulejo y Pisos',
        description:
          'Instalación de azulejo, piedra natural y pisos de madera premium, incluyendo base y pisos con calefacción.',
      },
      {
        id: 'custom-cabinetry',
        name: 'Gabinetes a Medida',
        description:
          'Gabinetes hechos a mano y diseñados para tu espacio, con herrajes de cierre suave y acabados duraderos.',
      },
      {
        id: 'handyman',
        name: 'Handyman General',
        description:
          'Mantenimiento, reparaciones y proyectos pequeños resueltos en una sola visita por un equipo con experiencia.',
      },
    ],
  },
  why: {
    eyebrow: 'Nosotros',
    title: '¿Por Qué Elegir Pollo Construction & Granite?',
    intro:
      'Dos décadas de experiencia atendiendo hogares en San Ysidro y el sur de California, un solo equipo y todos los oficios en casa. Sea cual sea el trabajo, quien cotiza es quien lo termina.',
    local:
      'De cocinas en San Ysidro a renovaciones completas en todo South Bay, Pollo Construction se ha ganado la confianza de cientos de familias con trabajo de calidad y atención personal.',
    highlight: 'Soluciones Completas Para el Hogar',
    highlightBody: 'Desde reparaciones pequeñas hasta renovaciones mayores.',
    points: [
      {
        id: 'craft',
        title: 'Mano de Obra Experta',
        description:
          'Profesionales con licencia y más de 20 años de experiencia en cada servicio que ofrecemos.',
      },
      {
        id: 'diverse',
        title: 'Experiencia Diversa',
        description:
          'No solo granito: techos, drywall, madera podrida, azulejo, gabinetes, handyman y más.',
      },
      {
        id: 'materials',
        title: 'Materiales de Calidad',
        description:
          'Materiales premium en cada proyecto, instalados según normas del fabricante y código local.',
      },
      {
        id: 'warranty',
        title: 'Garantía Completa',
        description:
          'Garantía de satisfacción y garantía escrita de mano de obra en todos nuestros servicios.',
      },
    ],
    cta: 'Agenda Tu Consulta Gratis',
  },
  portfolio: {
    title: 'Portafolio de Servicios',
    subtitle:
      'Una muestra del trabajo que terminamos cada semana en San Ysidro y las comunidades de South Bay.',
    filters: [
      { id: 'all', label: 'Todos los Servicios' },
      { id: 'roofing', label: 'Techos' },
      { id: 'drywall', label: 'Drywall' },
      { id: 'woodrot', label: 'Madera Podrida' },
      { id: 'granite', label: 'Granito' },
      { id: 'bathrooms', label: 'Baños' },
      { id: 'kitchens', label: 'Cocinas' },
    ],
    items: [
      {
        id: 'roof-install',
        title: 'Techo de Teja Arquitectónica',
        service: 'Servicios de Techos',
        category: 'roofing',
        caption: 'Retiro total, nueva base impermeable, ventilación y flashing.',
      },
      {
        id: 'drywall-finish',
        title: 'Interior con Acabado Liso',
        service: 'Drywall e Interiores',
        category: 'drywall',
        caption: 'Panel nuevo, con cinta, resanado y pintado a acabado nivel 5.',
      },
      {
        id: 'fascia-renewal',
        title: 'Renovación de Fascia y Molduras',
        service: 'Reparación de Madera Podrida',
        category: 'woodrot',
        caption: 'Fascia podrida reemplazada con madera tratada, sellada y pintada.',
      },
      {
        id: 'granite-kitchen',
        title: 'Isla de Granito en Cascada',
        service: 'Cubiertas de Granito',
        category: 'granite',
        caption: 'Absolute Noir con borde en cascada y salpicadero completo.',
      },
      {
        id: 'absolute-noir-slab',
        title: 'Losa Absolute Noir',
        service: 'Cubiertas de Granito',
        category: 'granite',
        caption: 'Negro profundo y uniforme con destellos plateados. Pulido, 3 cm.',
      },
      {
        id: 'copper-canyon-slab',
        title: 'Losa Copper Canyon',
        service: 'Cubiertas de Granito',
        category: 'granite',
        caption: 'Movimiento exótico en cobre y gris azulado. Cada losa es única.',
      },
      {
        id: 'spa-bathroom',
        title: 'Baño Tipo Spa',
        service: 'Diseño de Baños',
        category: 'bathrooms',
        caption: 'Tocador doble de granito, cristal sin marco y porcelanato grande.',
      },
      {
        id: 'open-kitchen',
        title: 'Cocina de Concepto Abierto',
        service: 'Remodelación de Cocinas',
        category: 'kitchens',
        caption: 'Retiro de muro, viga estructural y gabinetes a medida en dos tonos.',
      },
      {
        id: 'built-in-cabinetry',
        title: 'Muro de Gabinetes Integrados',
        service: 'Gabinetes a Medida',
        category: 'kitchens',
        caption: 'Gabinetes shaker de taller con iluminación LED integrada.',
      },
    ],
    cta: 'Solicita Tu Estimado Gratis',
    empty: 'Aún no hay proyectos en esta categoría. Llámanos y pregunta, seguro lo hemos hecho.',
  },
  granite: {
    items: [
      {
        id: 'absolute-noir',
        name: 'Absolute Noir',
        category: 'black',
        origin: 'India',
        finish: 'Pulido',
        thickness: '3 cm',
        description: 'Negro profundo y uniforme con destellos plateados.',
      },
      {
        id: 'silver-cloud',
        name: 'Silver Cloud',
        category: 'gray',
        origin: 'Brasil',
        finish: 'Pulido',
        thickness: '3 cm',
        description: 'Base blanca cremosa con vetas grises suaves.',
      },
      {
        id: 'steel-grey',
        name: 'Steel Grey',
        category: 'gray',
        origin: 'India',
        finish: 'Pulido o Mate',
        thickness: '2 o 3 cm',
        description: 'Gris medio frío con movimiento lineal.',
      },
      {
        id: 'cafe-imperial',
        name: 'Café Imperial',
        category: 'brown',
        origin: 'Brasil',
        finish: 'Pulido',
        thickness: '3 cm',
        description: 'Tonos café y caramelo con destellos dorados.',
      },
      {
        id: 'golden-sand',
        name: 'Golden Sand',
        category: 'brown',
        origin: 'Brasil',
        finish: 'Pulido',
        thickness: '3 cm',
        description: 'Tonos miel y arena con mucho detalle mineral.',
      },
      {
        id: 'copper-canyon',
        name: 'Copper Canyon',
        category: 'multi',
        origin: 'Brasil',
        finish: 'Pulido',
        thickness: '3 cm',
        description: 'Remolinos exóticos de cobre, crema y gris azulado.',
      },
    ],
    origin: 'Origen',
    finish: 'Acabado',
    thickness: 'Grosor',
    quoteThis: 'Cotizar esto',
  },
  projects: {
    title: 'Nuestro Trabajo en San Ysidro',
    subtitle: 'Transformamos hogares con trabajo de calidad y atención al detalle.',
    filters: [
      { id: 'all', label: 'Todos los Servicios' },
      { id: 'roofing', label: 'Techos' },
      { id: 'granite', label: 'Granito' },
      { id: 'bathrooms', label: 'Baños' },
      { id: 'handyman', label: 'Handyman' },
    ],
    before: 'Antes',
    after: 'Después',
    dragHint: 'Arrastra para comparar',
    viewDetails: 'Ver Detalles del Proyecto',
    ctaTitle: '¿Listo Para Transformar Tu Hogar?',
    ctaSub: 'Recibe un estimado gratis para tu proyecto en San Ysidro.',
    ctaConsult: 'Agendar Consulta Gratis',
    ctaCall: 'Llamar: (805) 310-6530',
    ctaServices: 'Ver Nuestros Servicios',
    items: [
      {
        id: 'roof-san-ysidro',
        name: 'Restauración de Techo por Tormenta',
        location: 'San Ysidro, CA',
        service: 'Contratista de Techos',
        category: 'roofing',
        description:
          'Restauración de techo por tormenta en San Ysidro, CA. Retiro completo y reemplazo con teja arquitectónica premium, flashing nuevo, ventilación y cumbrera. Garantía de 10 años en mano de obra.',
        detail:
          'Las tormentas levantaron y quebraron la teja del lado norte. Retiramos el techo hasta la cubierta, cambiamos madera dañada, instalamos base sintética, flashing nuevo en valles y chimenea, ventilación de cumbrera y teja arquitectónica premium. Terminado en cuatro días con limpieza total de clavos y garantía de 10 años en mano de obra.',
      },
      {
        id: 'granite-san-ysidro',
        name: 'Instalación de Cocina en Granito',
        location: 'San Ysidro, CA',
        service: 'Cubiertas de Granito',
        category: 'granite',
        description: 'Cubiertas Absolute Noir con isla en cascada a 45° y salpicadero nuevo.',
        detail:
          'Retiramos las cubiertas viejas, nivelamos los gabinetes y tomamos plantilla el mismo día. La isla se fabricó en cascada para que la veta continúe en la esquina. Lavabo bajo cubierta, bordes suaves y salpicadero completo en nueve días hábiles.',
      },
      {
        id: 'bathroom-san-ysidro',
        name: 'Renovación de Baño Moderno',
        location: 'San Ysidro, CA',
        service: 'Diseño de Baños',
        category: 'bathrooms',
        description:
          'Renovación completa incluyendo piso, tocador, grifería y regadera de azulejo a medida.',
        detail:
          'Demolición total, nueva impermeabilización y plomería reubicada para tocador doble. Cubierta de granito Steel Grey, porcelanato de gran formato, regadera con azulejo a medida, cristal sin marco y grifería negra mate.',
      },
      {
        id: 'handyman-san-ysidro',
        name: 'Actualizaciones y Reparaciones Interiores',
        location: 'San Ysidro, CA',
        service: 'Handyman General',
        category: 'handyman',
        description:
          'Mantenimiento completo del hogar con reparaciones, actualizaciones y mejoras en toda la casa.',
        detail:
          'Una sola visita para toda la lista: resanamos y pintamos muros, ajustamos marcos de puertas, cambiamos zoclos gastados, reemplazamos lámparas antiguas, ajustamos puertas duras y volvimos a sellar áreas húmedas. Dos días, un equipo, una factura.',
      },
    ],
  },
  process: {
    eyebrow: 'Cómo funciona',
    title: 'Nuestro Proceso',
    subtitle: 'Cinco pasos claros para cualquier servicio y una persona responsable todo el camino.',
    steps: [
      {
        id: 'consultation',
        name: 'Consulta',
        description: 'Estimado gratis en tu casa para cualquier servicio, con respuesta en 48 horas.',
      },
      {
        id: 'assessment',
        name: 'Evaluación',
        description: 'Evaluación profesional del trabajo y planeación detallada por escrito.',
      },
      {
        id: 'materials',
        name: 'Selección de Material',
        description: 'Elige acabados, materiales y opciones de diseño con nuestra asesoría.',
      },
      {
        id: 'construction',
        name: 'Construcción',
        description: 'Instalación experta y trabajo calificado por nuestro propio equipo.',
      },
      {
        id: 'inspection',
        name: 'Inspección',
        description: 'Recorrido final, control de calidad y nuestra garantía de satisfacción.',
      },
    ],
    cta: 'Comienza Con un Estimado Gratis',
  },
  testimonials: {
    title: 'Lo Que Dicen Nuestros Clientes',
    subtitle: 'Proyectos reales en cada servicio que ofrecemos.',
    items: [
      {
        id: 'maria-l',
        quote:
          'Tomaron la plantilla un lunes e instalaron el jueves. La unión en la isla casi no se ve y el equipo dejó todo más limpio de como lo encontró.',
        name: 'Maria L.',
        meta: 'San Ysidro, CA • Cubiertas de Granito',
      },
      {
        id: 'carlos-r',
        quote:
          'Después de la tormenta nos quedamos sin la mitad del techo. Llegaron al día siguiente, cubrieron todo y en cuatro días teníamos techo nuevo. Gente honesta y muy trabajadora.',
        name: 'Carlos R.',
        meta: 'San Ysidro, CA • Reemplazo de Techo',
      },
      {
        id: 'david-h',
        quote:
          'Demolieron nuestro baño principal y lo dejaron mejor que las fotos del catálogo. El mismo equipo todos los días y el azulejo de la regadera quedó perfecto.',
        name: 'David H.',
        meta: 'Chula Vista, CA • Renovación de Baño',
      },
      {
        id: 'james-m',
        quote:
          'Tenía una lista de doce reparaciones pequeñas que nadie quería hacer. Las terminaron todas en dos días y cobraron exactamente lo cotizado.',
        name: 'James M.',
        meta: 'Imperial Beach, CA • Handyman General',
      },
    ],
    prev: 'Testimonio anterior',
    next: 'Testimonio siguiente',
    goTo: 'Ir al testimonio',
  },
  care: {
    title: 'Consejos de Mantenimiento del Hogar',
    subtitle: 'Hábitos simples que protegen tu hogar y tu inversión entre proyectos.',
    items: [
      {
        id: 'roof',
        title: 'Mantenimiento de Techo',
        description:
          'Revisa una vez al año y después de tormentas fuertes. Limpia canaletas, corta ramas cercanas y cambia tejas levantadas antes de que entre el agua.',
      },
      {
        id: 'drywall',
        title: 'Cuidado del Drywall',
        description:
          'Casi todo daño empieza por humedad. Deja el extractor 20 minutos después de bañarte, repara fugas rápido y usa pintura resistente a humedad.',
      },
      {
        id: 'wood',
        title: 'Protección de Madera',
        description:
          'Mantén molduras, fascia y terrazas selladas. Vuelve a aplicar sellador cada pocos años y revisa donde se desbordan las canaletas.',
      },
      {
        id: 'sealing',
        title: 'Sellado del Granito',
        description:
          'La mayoría del granito se sella cada 12 a 18 meses. Pon agua en la superficie: si se oscurece en 5 minutos, hay que sellar.',
      },
      {
        id: 'cleaning',
        title: 'Limpieza de Superficies',
        description:
          'Agua tibia, jabón suave y un paño es todo lo que necesitas a diario. Evita vinagre, cloro y limpiadores con cítricos.',
      },
      {
        id: 'prevention',
        title: 'Prevención de Daños',
        description:
          'Usa bases para ollas calientes, tablas para cortar y limpia rápido el vino, aceite y café para evitar manchas.',
      },
    ],
    cta: 'Descargar Guía de Cuidado (PDF)',
  },
  cta: {
    title: 'Hagamos Tu Hogar Realidad',
    sub: 'Contáctanos hoy para una consulta gratis y un estimado por escrito de cualquier servicio.',
    call: 'Llamar (805) 310-6530',
    quote: 'Cotización Gratis',
  },
  contact: {
    title: 'Solicita Tu Cotización Gratis',
    subtitle:
      'Cuéntanos de tu proyecto en el área de San Ysidro y te llamamos el mismo día hábil.',
    formTitle: 'Detalles del proyecto',
    name: 'Nombre completo',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    service: 'Servicio de interés',
    servicePlaceholder: 'Selecciona un servicio',
    serviceOther: 'Otro (descríbelo)',
    granite: 'Granito seleccionado (opcional)',
    granitePlaceholder: 'No aplica / aún no estoy seguro',
    message: 'Descripción del proyecto',
    messagePlaceholder: 'Alcance, fechas y cualquier detalle importante…',
    submit: 'Solicitar Cotización Gratis',
    submitting: 'Enviando…',
    privacy:
      'Usamos tu información solo para contactarte sobre tu proyecto. Sin spam y sin compartirla con terceros.',
    successTitle: 'Solicitud recibida',
    successBody:
      '¡Gracias! Tenemos los detalles de tu proyecto y te llamaremos el mismo día hábil. Si es urgente, llama al (805) 310-6530.',
    successAgain: 'Enviar otra solicitud',
    errors: {
      name: 'Por favor escribe tu nombre.',
      phone: 'Escribe un teléfono válido de 10 dígitos.',
      email: 'Escribe un correo electrónico válido.',
      service: 'Por favor elige un servicio.',
      message: 'Cuéntanos un poco del proyecto (10+ caracteres).',
    },
    infoTitle: 'Información de contacto',
    areaLabel: 'Área de servicio',
    areaValue: 'San Ysidro, California',
    phoneLabel: 'Teléfono',
    emailLabel: 'Correo',
    licenseLabel: 'Licencia',
    hoursLabel: 'Horario',
    hours: ['Lunes – Viernes: 7:00 AM – 6:00 PM', 'Sábado: 8:00 AM – 2:00 PM', 'Domingo: Cerrado'],
    mapLabel: 'Mapa de nuestra área de servicio en California',
    followLabel: 'Síguenos',
  },
  footer: {
    about:
      'Contratista de construcción residencial con licencia que atiende San Ysidro, California y las comunidades de South Bay. Especialista en renovación completa, empresa familiar con equipo propio y experta en techos, drywall, reparación de madera, granito y todos los servicios del hogar.',
    serviceArea: 'Área de servicio: San Ysidro, CA | Licencia: Lic. 1126459',
    proudly:
      'Con orgullo atendemos San Ysidro, California con servicios profesionales de construcción, renovación y reparación del hogar.',
    quickLinks: 'Enlaces rápidos',
    contact: 'Contacto',
    follow: 'Síguenos',
    privacy: 'Aviso de Privacidad',
    terms: 'Términos',
    rights: 'Todos los derechos reservados.',
    licensed: 'Con Licencia y Asegurados',
  },
}
